/** The different themes we use for styling different archives */
export enum ArchiveTheme {
  Icpsr,
  Neutral,
}
